// Mirrors Tp_Communication.Enum.InvoiceAutomationOutOfScopeTypeTextEnum — keep in sync.
const InvoiceAutomationOutOfScopeTypeEnum = {
  TakenOff: 'TakenOff',
  BeforeFirstMonth: 'BeforeFirstMonth',
  MonthCancelled: 'MonthCancelled',
};

export default InvoiceAutomationOutOfScopeTypeEnum;
